export default __webpack_public_path__ + "static/media/report-analytics-usage.29aeeeef.png";